import { LitElement as xt, html as A, nothing as x, unsafeCSS as Ft } from "lit";
import { query as nt, property as E } from "lit/decorators.js";
import { FormControlMixin as At, RtlMixin as It, wrapNativeEvent as St, validPropertyValues as Tt, defineCustomElement as Vt } from "@justeattakeaway/pie-webc-core";
import "@justeattakeaway/pie-icons-webc/IconCheck";
const Lt = `*,*:after,*:before{box-sizing:inherit}*,*:before,*:after{cursor:inherit}.c-switch-wrapper{display:inline-flex;align-items:center;gap:var(--dt-spacing-b);font-family:var(--dt-font-body-l-family);cursor:pointer}.c-switch-wrapper[disabled]{cursor:not-allowed}.c-switch{--switch-bg-color: var(--dt-color-interactive-form);--switch-bg-color--checked: var(--dt-color-interactive-brand);--switch-bg-color--disabled: var(--dt-color-disabled-01);--switch-width: 48px;--switch-height: 24px;--switch-control-size: 20px;--switch-padding: 2px;--switch-radius: var(--dt-radius-rounded-e);--switch-translation: calc(var(--switch-width) - var(--switch-control-size) - 2 * var(--switch-padding));position:relative;display:flex;width:var(--switch-width);height:var(--switch-height);flex-shrink:0;padding:var(--switch-padding);border-radius:var(--switch-radius);background-color:var(--switch-bg-color)}@media (prefers-reduced-motion: no-preference){.c-switch{transition:background-color .15s cubic-bezier(.4,0,.9,1) 0s}}.c-switch:hover{background-color:hsl(var(--dt-color-interactive-form-h),var(--dt-color-interactive-form-s),calc(var(--dt-color-interactive-form-l) - var(--dt-color-hover-01)))}.c-switch:focus,.c-switch:focus-within{box-shadow:0 0 0 2px var(--dt-color-focus-inner),0 0 0 4px var(--dt-color-focus-outer);outline:none}.c-switch:active{background-color:hsl(var(--dt-color-interactive-form-h),var(--dt-color-interactive-form-s),calc(var(--dt-color-interactive-form-l) - var(--dt-color-active-01)))}.c-switch[checked]{background-color:var(--switch-bg-color--checked)}@media (prefers-reduced-motion: no-preference){.c-switch[checked]{transition:background-color .15s cubic-bezier(.4,0,.9,1) 0s}}.c-switch[checked]:hover{background-color:hsl(var(--dt-color-interactive-brand-h),var(--dt-color-interactive-brand-s),calc(var(--dt-color-interactive-brand-l) - var(--dt-color-hover-01)))}.c-switch[checked]:focus,.c-switch[checked]:focus-within{background-color:var(--switch-bg-color--checked)}.c-switch[checked]:active{background-color:hsl(var(--dt-color-interactive-brand-h),var(--dt-color-interactive-brand-s),calc(var(--dt-color-interactive-brand-l) - var(--dt-color-active-01)))}[disabled] .c-switch{background-color:var(--switch-bg-color--disabled);pointer-events:none}.c-switch-input{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;left:50%;transform:translate(-50%) translateY(-50%);bottom:0}.c-switch-input:disabled{background-color:transparent}.c-switch-control{position:absolute;left:2px;width:var(--switch-control-size);height:var(--switch-control-size);border-radius:var(--switch-radius);background-color:var(--dt-color-interactive-light);padding:var(--switch-padding)}@media (prefers-reduced-motion: no-preference){.c-switch-control{transition:transform .15s cubic-bezier(.4,0,.9,1) 0s}}.c-switch-input:checked+.c-switch-control{transform:translate(var(--switch-translation))}@media (prefers-reduced-motion: no-preference){.c-switch-input:checked+.c-switch-control{transition:transform .15s cubic-bezier(.4,0,.9,1) 0s}}.c-switch-input:checked+.c-switch-control .c-pieIcon--check{color:var(--switch-bg-color--checked)}@media (prefers-reduced-motion: no-preference){.c-switch-input:checked+.c-switch-control .c-pieIcon--check{transition:color .15s cubic-bezier(.4,0,.9,1) 0s}}.c-switch-input:disabled~.c-switch-control{color:var(--switch-bg-color--disabled)}.c-switch-input:disabled~.c-switch-control .c-pieIcon--check{color:var(--switch-bg-color--disabled)}@media (prefers-reduced-motion: no-preference){.c-switch-input:disabled~.c-switch-control .c-pieIcon--check{transition:color .15s cubic-bezier(.4,0,.9,1) 0s}}.c-switch-description{position:absolute;display:block;height:1px;width:1px;overflow:hidden;padding:1px;white-space:nowrap}.c-switch-wrapper[isRTL] .c-switch-control{position:absolute;left:initial;right:2px}.c-switch-wrapper[isRTL] .c-switch-input:checked+.c-switch-control{transform:translate(calc(-1 * var(--switch-translation)))}@media (prefers-reduced-motion: no-preference){.c-switch-wrapper[isRTL] .c-switch-input:checked+.c-switch-control{transition:transform .15s cubic-bezier(.4,0,.9,1) 0s}}
`, Nt = ["leading", "trailing"], Wt = "change";
(function() {
  (function(v) {
    const n = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap(), k = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap(), W = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap(), z = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), q = /* @__PURE__ */ new WeakMap(), U = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), T = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, lt = (e, t) => {
      for (let i in T) {
        t[i] = null;
        let a = null;
        const r = T[i];
        Object.defineProperty(t, i, {
          get() {
            return a;
          },
          set(o) {
            a = o, e.isConnected ? e.setAttribute(r, o) : I.set(e, t);
          }
        });
      }
    };
    function K(e) {
      const t = l.get(e), { form: i } = t;
      X(e, i, t), Q(e, t.labels);
    }
    const j = (e, t = !1) => {
      const i = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
        acceptNode(o) {
          return l.has(o) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let a = i.nextNode();
      const r = !t || e.disabled;
      for (; a; )
        a.formDisabledCallback && r && $(a, e.disabled), a = i.nextNode();
    }, G = { attributes: !0, attributeFilter: ["disabled", "name"] }, C = N() ? new MutationObserver((e) => {
      for (const t of e) {
        const i = t.target;
        if (t.attributeName === "disabled" && (i.constructor.formAssociated ? $(i, i.hasAttribute("disabled")) : i.localName === "fieldset" && j(i)), t.attributeName === "name" && i.constructor.formAssociated) {
          const a = l.get(i), r = W.get(i);
          a.setFormValue(r);
        }
      }
    }) : {};
    function P(e) {
      e.forEach((t) => {
        const { addedNodes: i, removedNodes: a } = t, r = Array.from(i), o = Array.from(a);
        r.forEach((s) => {
          var u;
          if (l.has(s) && s.constructor.formAssociated && K(s), I.has(s)) {
            const d = I.get(s);
            Object.keys(T).filter((f) => d[f] !== null).forEach((f) => {
              s.setAttribute(T[f], d[f]);
            }), I.delete(s);
          }
          if (S.has(s)) {
            const d = S.get(s);
            s.setAttribute("internals-valid", d.validity.valid.toString()), s.setAttribute("internals-invalid", (!d.validity.valid).toString()), s.setAttribute("aria-invalid", (!d.validity.valid).toString()), S.delete(s);
          }
          if (s.localName === "form") {
            const d = y.get(s), g = document.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, {
              acceptNode(D) {
                return l.has(D) && D.constructor.formAssociated && !(d && d.has(D)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let f = g.nextNode();
            for (; f; )
              K(f), f = g.nextNode();
          }
          s.localName === "fieldset" && ((u = C.observe) == null || u.call(C, s, G), j(s, !0));
        }), o.forEach((s) => {
          const u = l.get(s);
          u && h.get(u) && Y(u), M.has(s) && M.get(s).disconnect();
        });
      });
    }
    function dt(e) {
      e.forEach((t) => {
        const { removedNodes: i } = t;
        i.forEach((a) => {
          const r = q.get(t.target);
          l.has(a) && tt(a), r.disconnect();
        });
      });
    }
    const ht = (e) => {
      var i, a;
      const t = new MutationObserver(dt);
      (i = window == null ? void 0 : window.ShadyDOM) != null && i.inUse && e.mode && e.host && (e = e.host), (a = t.observe) == null || a.call(t, e, { childList: !0 }), q.set(e, t);
    };
    N() && new MutationObserver(P);
    const R = {
      childList: !0,
      subtree: !0
    }, $ = (e, t) => {
      e.toggleAttribute("internals-disabled", t), t ? e.setAttribute("aria-disabled", "true") : e.removeAttribute("aria-disabled"), e.formDisabledCallback && e.formDisabledCallback.apply(e, [t]);
    }, Y = (e) => {
      h.get(e).forEach((i) => {
        i.remove();
      }), h.set(e, []);
    }, J = (e, t) => {
      const i = document.createElement("input");
      return i.type = "hidden", i.name = e.getAttribute("name"), e.after(i), h.get(t).push(i), i;
    }, ut = (e, t) => {
      var i;
      h.set(t, []), (i = C.observe) == null || i.call(C, e, G);
    }, Q = (e, t) => {
      if (t.length) {
        Array.from(t).forEach((a) => a.addEventListener("click", e.click.bind(e)));
        let i = t[0].id;
        t[0].id || (i = `${t[0].htmlFor}_Label`, t[0].id = i), e.setAttribute("aria-labelledby", i);
      }
    }, V = (e) => {
      const t = Array.from(e.elements).filter((o) => !o.tagName.includes("-") && o.validity).map((o) => o.validity.valid), i = y.get(e) || [], a = Array.from(i).filter((o) => o.isConnected).map((o) => l.get(o).validity.valid), r = [...t, ...a].includes(!1);
      e.toggleAttribute("internals-invalid", r), e.toggleAttribute("internals-valid", !r);
    }, pt = (e) => {
      V(L(e.target));
    }, ft = (e) => {
      V(L(e.target));
    }, mt = (e) => {
      const t = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((i) => `${i}:not([disabled])`).map((i) => `${i}:not([form])${e.id ? `,${i}[form='${e.id}']` : ""}`).join(",");
      e.addEventListener("click", (i) => {
        if (i.target.closest(t)) {
          const r = y.get(e);
          if (e.noValidate)
            return;
          r.size && Array.from(r).reverse().map((u) => l.get(u).reportValidity()).includes(!1) && i.preventDefault();
        }
      });
    }, wt = (e) => {
      const t = y.get(e.target);
      t && t.size && t.forEach((i) => {
        i.constructor.formAssociated && i.formResetCallback && i.formResetCallback.apply(i);
      });
    }, X = (e, t, i) => {
      if (t) {
        const a = y.get(t);
        if (a)
          a.add(e);
        else {
          const r = /* @__PURE__ */ new Set();
          r.add(e), y.set(t, r), mt(t), t.addEventListener("reset", wt), t.addEventListener("input", pt), t.addEventListener("change", ft);
        }
        k.set(t, { ref: e, internals: i }), e.constructor.formAssociated && e.formAssociatedCallback && setTimeout(() => {
          e.formAssociatedCallback.apply(e, [t]);
        }, 0), V(t);
      }
    }, L = (e) => {
      let t = e.parentNode;
      return t && t.tagName !== "FORM" && (t = L(t)), t;
    }, b = (e, t, i = DOMException) => {
      if (!e.constructor.formAssociated)
        throw new i(t);
    }, Z = (e, t, i) => {
      const a = y.get(e);
      return a && a.size && a.forEach((r) => {
        l.get(r)[i]() || (t = !1);
      }), t;
    }, tt = (e) => {
      if (e.constructor.formAssociated) {
        const t = l.get(e), { labels: i, form: a } = t;
        Q(e, i), X(e, a, t);
      }
    };
    function N() {
      return typeof MutationObserver < "u";
    }
    class bt {
      constructor() {
        this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
      }
    }
    const gt = (e) => (e.badInput = !1, e.customError = !1, e.patternMismatch = !1, e.rangeOverflow = !1, e.rangeUnderflow = !1, e.stepMismatch = !1, e.tooLong = !1, e.tooShort = !1, e.typeMismatch = !1, e.valid = !0, e.valueMissing = !1, e), vt = (e, t, i) => (e.valid = yt(t), Object.keys(t).forEach((a) => e[a] = t[a]), i && V(i), e), yt = (e) => {
      let t = !0;
      for (let i in e)
        i !== "valid" && e[i] !== !1 && (t = !1);
      return t;
    }, O = /* @__PURE__ */ new WeakMap();
    function et(e, t) {
      e.toggleAttribute(t, !0), e.part && e.part.add(t);
    }
    class _ extends Set {
      static get isPolyfilled() {
        return !0;
      }
      constructor(t) {
        if (super(), !t || !t.tagName || t.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        O.set(this, t);
      }
      add(t) {
        if (!/^--/.test(t) || typeof t != "string")
          throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${t} must start with '--'.`);
        const i = super.add(t), a = O.get(this), r = `state${t}`;
        return a.isConnected ? et(a, r) : setTimeout(() => {
          et(a, r);
        }), i;
      }
      clear() {
        for (let [t] of this.entries())
          this.delete(t);
        super.clear();
      }
      delete(t) {
        const i = super.delete(t), a = O.get(this);
        return a.isConnected ? (a.toggleAttribute(`state${t}`, !1), a.part && a.part.remove(`state${t}`)) : setTimeout(() => {
          a.toggleAttribute(`state${t}`, !1), a.part && a.part.remove(`state${t}`);
        }), i;
      }
    }
    function it(e, t, i, a) {
      if (i === "a" && !a)
        throw new TypeError("Private accessor was defined without a getter");
      if (typeof t == "function" ? e !== t || !a : !t.has(e))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return i === "m" ? a : i === "a" ? a.call(e) : a ? a.value : t.get(e);
    }
    function Et(e, t, i, a, r) {
      if (a === "m")
        throw new TypeError("Private method is not writable");
      if (a === "a" && !r)
        throw new TypeError("Private accessor was defined without a setter");
      if (typeof t == "function" ? e !== t || !r : !t.has(e))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return a === "a" ? r.call(e, i) : r ? r.value = i : t.set(e, i), i;
    }
    var F;
    class kt {
      constructor(t) {
        F.set(this, void 0), Et(this, F, t, "f");
        for (let i = 0; i < t.length; i++) {
          let a = t[i];
          this[i] = a, a.hasAttribute("name") && (this[a.getAttribute("name")] = a);
        }
        Object.freeze(this);
      }
      get length() {
        return it(this, F, "f").length;
      }
      [(F = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return it(this, F, "f")[Symbol.iterator]();
      }
      item(t) {
        return this[t] == null ? null : this[t];
      }
      namedItem(t) {
        return this[t] == null ? null : this[t];
      }
    }
    function Mt() {
      const e = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = i;
      const t = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = a;
      function i(...o) {
        let s = e.apply(this, o);
        return Z(this, s, "checkValidity");
      }
      function a(...o) {
        let s = t.apply(this, o);
        return Z(this, s, "reportValidity");
      }
      const { get: r } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...o) {
          const s = r.call(this, ...o), u = Array.from(y.get(this) || []);
          if (u.length === 0)
            return s;
          const d = Array.from(s).concat(u).sort((g, f) => g.compareDocumentPosition ? g.compareDocumentPosition(f) & 2 ? 1 : -1 : 0);
          return new kt(d);
        }
      });
    }
    class at {
      static get isPolyfilled() {
        return !0;
      }
      constructor(t) {
        if (!t || !t.tagName || t.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const i = t.getRootNode(), a = new bt();
        this.states = new _(t), n.set(this, t), c.set(this, a), l.set(t, this), lt(t, this), ut(t, this), Object.seal(this), i instanceof DocumentFragment && ht(i);
      }
      checkValidity() {
        const t = n.get(this);
        if (b(t, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const i = c.get(this);
        if (!i.valid) {
          const a = new Event("invalid", {
            bubbles: !1,
            cancelable: !0,
            composed: !1
          });
          t.dispatchEvent(a);
        }
        return i.valid;
      }
      get form() {
        const t = n.get(this);
        b(t, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let i;
        return t.constructor.formAssociated === !0 && (i = L(t)), i;
      }
      get labels() {
        const t = n.get(this);
        b(t, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const i = t.getAttribute("id"), a = t.getRootNode();
        return a && i ? a.querySelectorAll(`[for="${i}"]`) : [];
      }
      reportValidity() {
        const t = n.get(this);
        if (b(t, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const i = this.checkValidity(), a = B.get(this);
        if (a && !t.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !i && a && (t.focus(), a.focus()), i;
      }
      setFormValue(t) {
        const i = n.get(this);
        if (b(i, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), Y(this), t != null && !(t instanceof FormData)) {
          if (i.getAttribute("name")) {
            const a = J(i, this);
            a.value = t;
          }
        } else
          t != null && t instanceof FormData && Array.from(t).reverse().forEach(([a, r]) => {
            if (typeof r == "string") {
              const o = J(i, this);
              o.name = a, o.value = r;
            }
          });
        W.set(i, t);
      }
      setValidity(t, i, a) {
        const r = n.get(this);
        if (b(r, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !t)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        B.set(this, a);
        const o = c.get(this), s = {};
        for (const g in t)
          s[g] = t[g];
        Object.keys(s).length === 0 && gt(o);
        const u = { ...o, ...s };
        delete u.valid;
        const { valid: d } = vt(o, u, this.form);
        if (!d && !i)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        w.set(this, d ? "" : i), r.isConnected ? (r.toggleAttribute("internals-invalid", !d), r.toggleAttribute("internals-valid", d), r.setAttribute("aria-invalid", `${!d}`)) : S.set(r, this);
      }
      get shadowRoot() {
        const t = n.get(this), i = z.get(t);
        return i || null;
      }
      get validationMessage() {
        const t = n.get(this);
        return b(t, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), w.get(this);
      }
      get validity() {
        const t = n.get(this);
        return b(t, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), c.get(this);
      }
      get willValidate() {
        const t = n.get(this);
        return b(t, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(t.disabled || t.hasAttribute("disabled") || t.hasAttribute("readonly"));
      }
    }
    function Ct() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return !1;
      class e extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const t = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
      customElements.define(t, e);
      const i = new e();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((a) => a in i.internals);
    }
    let rt = !1, ot = !1;
    function H(e) {
      ot || (ot = !0, window.CustomStateSet = _, e && (HTMLElement.prototype.attachInternals = function(...t) {
        const i = e.call(this, t);
        return i.states = new _(this), i;
      }));
    }
    function st(e = !0) {
      if (!rt) {
        if (rt = !0, typeof window < "u" && (window.ElementInternals = at), typeof CustomElementRegistry < "u") {
          const t = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(i, a, r) {
            if (a.formAssociated) {
              const o = a.prototype.connectedCallback;
              a.prototype.connectedCallback = function() {
                U.has(this) || (U.set(this, !0), this.hasAttribute("disabled") && $(this, !0)), o != null && o.apply(this), tt(this);
              };
            }
            t.call(this, i, a, r);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else
            return {};
          if (l.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new at(this);
        }), typeof Element < "u") {
          let t = function(...a) {
            const r = i.apply(this, a);
            if (z.set(this, r), N()) {
              const o = new MutationObserver(P);
              window.ShadyDOM ? o.observe(this, R) : o.observe(r, R), M.set(this, o);
            }
            return r;
          };
          const i = Element.prototype.attachShadow;
          Element.prototype.attachShadow = t;
        }
        N() && typeof document < "u" && new MutationObserver(P).observe(document.documentElement, R), typeof HTMLFormElement < "u" && Mt(), (e || typeof window < "u" && !window.CustomStateSet) && H();
      }
    }
    return !!customElements.polyfillWrapFlushCallback || (Ct() ? typeof window < "u" && !window.CustomStateSet && H(HTMLElement.prototype.attachInternals) : st(!1)), v.forceCustomStateSetPolyfill = H, v.forceElementInternalsPolyfill = st, Object.defineProperty(v, "__esModule", { value: !0 }), v;
  })({});
})();
var Pt = Object.defineProperty, Rt = Object.getOwnPropertyDescriptor, m = (v, n, c, h) => {
  for (var l = h > 1 ? void 0 : h ? Rt(n, c) : n, w = v.length - 1, k; w >= 0; w--)
    (k = v[w]) && (l = (h ? k(n, c, l) : k(l)) || l);
  return h && l && Pt(n, c, l), l;
};
const ct = "pie-switch";
class p extends At(It(xt)) {
  constructor() {
    super(...arguments), this.labelPlacement = "leading", this.checked = !1, this.required = !1, this.value = "on", this.disabled = !1;
  }
  firstUpdated(n) {
    var c;
    super.firstUpdated(n), this.handleFormAssociation(), (c = this.input) == null || c.addEventListener("invalid", (h) => {
      this.dispatchEvent(new Event("invalid", h));
    });
  }
  updated(n) {
    super.updated(n), this.handleFormAssociation();
  }
  /**
   * Ensures that the form value and validation state are in sync with the component.
   */
  handleFormAssociation() {
    !!this._internals.form && !!this.name && !!this.value && (this.disabled ? (this._internals.setFormValue(null), this._internals.setValidity({})) : this.checked ? (this._internals.setFormValue(this.value), this._internals.setValidity({})) : (this._internals.setFormValue(null), this._internals.setValidity(this.validity, this.validationMessage, this.input)));
  }
  /**
   * The onChange function updates the checkbox state and emits an event for consumers.
   * @param {Event} event - This should be the change event that was listened for on an input element with `type="checkbox"`.
   */
  onChange(n) {
    const { checked: c } = n == null ? void 0 : n.currentTarget;
    this.checked = c;
    const h = St(n);
    this.dispatchEvent(h), this.handleFormAssociation();
  }
  /**
   * Returns a boolean value which indicates validity of the value of the component. If the value is invalid, this method also fires the invalid event on the component.
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/checkValidity
   * @returns boolean
   */
  checkValidity() {
    return this.input.checkValidity();
  }
  /**
   * If the value is invalid, this method also fires the invalid event on the element, and (if the event isn't canceled) reports the problem to the user.
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/reportValidity
   * @returns boolean
   */
  reportValidity() {
    return this.input.reportValidity();
  }
  /**
   * Allows a consumer to set a custom validation message on the switch. An empty string counts as valid.
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setCustomValidity
   */
  setCustomValidity(n) {
    var c;
    (c = this.input) == null || c.setCustomValidity(n), this._internals.setValidity(this.validity, this.validationMessage, this.input);
  }
  /**
   * (Read-only) returns a ValidityState with the validity states that this element is in.
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLObjectElement/validity
   */
  get validity() {
    return this.input.validity;
  }
  /**
   * (Read-only) Returns a string representing a localized message that describes the validation constraints that the control does not satisfy (if any).
   * This string is empty if the component is valid.
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLObjectElement/validationMessage
   */
  get validationMessage() {
    return this.input.validationMessage;
  }
  /**
   * Renders the label for a switch if provided.
   * if invalid value is passed, nothing gets rendered
   *
   * @private
   */
  renderSwitchLabel() {
    const { label: n, labelPlacement: c } = this;
    return n ? A`
                <label
                    for="switch"
                    data-test-id="switch-label-${c}">
                    ${n}
                </label>` : A``;
  }
  render() {
    const {
      labelPlacement: n,
      aria: c,
      checked: h,
      required: l,
      disabled: w,
      isRTL: k
    } = this, M = "switch-description";
    return A`
            <div
                class="c-switch-wrapper"
                ?isRTL=${k}
                ?disabled=${w}>
                ${n === "leading" ? this.renderSwitchLabel() : x}
                <label
                    data-test-id="switch-component"
                    class="c-switch"
                    ?checked=${h}>
                    <input
                        id="switch"
                        data-test-id="switch-input"
                        role="switch"
                        type="checkbox"
                        class="c-switch-input"
                        .required=${l}
                        .checked="${h}"
                        .disabled="${w}"
                        @change="${this.onChange}"
                        aria-label="${(c == null ? void 0 : c.label) || x}"
                        aria-describedby="${c != null && c.describedBy ? M : x}">
                    <div class="c-switch-control">
                        ${h ? A`<icon-check></icon-check>` : x}
                    </div>
                </label>
                ${c != null && c.describedBy ? A`<div id="${M}" data-test-id="${M}" class="c-switch-description">${c == null ? void 0 : c.describedBy}</div>` : x}
                ${n === "trailing" ? this.renderSwitchLabel() : x}
            </div>
        `;
  }
}
p.styles = Ft(Lt);
m([
  nt('input[type="checkbox"]')
], p.prototype, "input", 2);
m([
  E({ type: String })
], p.prototype, "label", 2);
m([
  E({ type: String }),
  Tt(ct, Nt, "leading")
], p.prototype, "labelPlacement", 2);
m([
  E({ type: Object })
], p.prototype, "aria", 2);
m([
  E({ type: Boolean, reflect: !0 })
], p.prototype, "checked", 2);
m([
  E({ type: Boolean, reflect: !0 })
], p.prototype, "required", 2);
m([
  E({ type: String })
], p.prototype, "value", 2);
m([
  E({ type: String })
], p.prototype, "name", 2);
m([
  E({ type: Boolean, reflect: !0 })
], p.prototype, "disabled", 2);
m([
  nt("label")
], p.prototype, "focusTarget", 2);
Vt(ct, p);
export {
  Wt as ON_SWITCH_CHANGED_EVENT,
  p as PieSwitch,
  Nt as labelPlacements
};
